import { Box } from "@mui/material";
import { useState } from "react";

import DesktopSidebar from "./DesktopSidebar";

const SIDEBAR_WIDTH = 247;
const SIDEBAR_COLLAPSED_WIDTH = 68;

const SidebarDrawer = () => {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem("sidebar-collapsed") === "true";
  });

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      const next = !prev;
      localStorage.setItem("sidebar-collapsed", String(next));
      return next;
    });
  };

  const width = collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH;

  return (
    <Box
      component="nav"
      sx={{
        width,
        flexShrink: 0,
        transition: "width 0.2s ease-out",
      }}
    >
      <DesktopSidebar
        width={width}
        collapsed={collapsed}
        onToggleCollapse={toggleCollapsed}
      />
    </Box>
  );
};

export default SidebarDrawer;
